.bar {
  height: var(--topbar-h);
  flex: none;
  display: grid; grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 0 20px;
  background: var(--bg-overlay);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid var(--border);
  z-index: 10;
}

.brand { display: flex; align-items: center; gap: 10px; }
.wordmark { font-weight: 700; letter-spacing: 1.5px; font-size: var(--fs-lg); }
.tv { color: var(--accent); }

.nav {
  display: flex; align-items: center; gap: 4px;
  background: var(--bg-elevated);
  border: 1px solid var(--border);
  padding: 4px;
  border-radius: 999px;
}
.nav a {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 6px 14px; border-radius: 999px;
  color: var(--text-secondary);
  font-size: var(--fs-md);
  transition: color var(--dur-fast) var(--ease), background var(--dur-fast) var(--ease);
}
.nav a:hover { color: var(--text-primary); }
.nav a.active, .nav .active { background: var(--accent); color: #fff; }

.right { display: flex; justify-content: flex-end; gap: 8px; align-items: center; }

.userWrap { position: relative; }
.userBtn {
  display: flex; align-items: center; gap: 8px;
  padding: 4px 10px 4px 4px; border-radius: 999px;
  background: var(--bg-elevated);
  border: 1px solid var(--border);
}
.userBtn:hover { background: var(--bg-elevated-2); }
.avatar {
  width: 28px; height: 28px; border-radius: 50%;
  background: var(--accent); color: #fff;
  display: flex; align-items: center; justify-content: center;
  font-weight: 600; font-size: var(--fs-sm);
}
.userName { font-size: var(--fs-sm); }

.menu {
  position: absolute; right: 0; top: calc(100% + 6px);
  min-width: 220px;
  background: var(--bg-elevated);
  border: 1px solid var(--border-strong);
  border-radius: var(--r-md);
  box-shadow: var(--shadow-md);
  padding: 6px;
  animation: pop var(--dur-fast) var(--ease);
  z-index: 30;
}
@keyframes pop { from { opacity: 0; transform: translateY(-4px); } to { opacity: 1; transform: none; } }
.menuHeader { padding: 8px 10px 10px; border-bottom: 1px solid var(--border); margin-bottom: 4px; }
.menuName { font-weight: 600; }
.menuEmail { font-size: var(--fs-sm); color: var(--text-secondary); }
.menuItem {
  display: flex; align-items: center; gap: 8px;
  width: 100%;
  padding: 8px 10px;
  border-radius: var(--r-sm);
  font-size: var(--fs-md);
  text-align: left;
  color: var(--text-primary);
}
.menuItem:hover:not(:disabled) { background: var(--bg-elevated-2); }
.menuItem:disabled { color: var(--text-muted); cursor: not-allowed; }
.menuDivider { height: 1px; background: var(--border); margin: 4px 0; }
.menuItemActive { background: var(--accent-soft); color: var(--accent-hover); }

.tzBtn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 5px 10px; border-radius: 999px;
  background: var(--bg-elevated);
  border: 1px solid var(--border);
  color: var(--text-secondary);
  font-size: var(--fs-xs);
  font-variant-numeric: tabular-nums;
}
.tzBtn:hover { background: var(--bg-elevated-2); color: var(--text-primary); }
.tzLabel { color: var(--text-primary); font-weight: 500; }

.tzMenu {
  min-width: 200px;
  max-height: 60vh;
  overflow-y: auto;
}
